export const BOOKED = "flight/booked";
export const REMOVED = "flight/removed";
